import { render, staticRenderFns } from "./ReferAFriendModal.vue?vue&type=template&id=0f929f37&scoped=true&"
import script from "./ReferAFriendModal.vue?vue&type=script&lang=ts&"
export * from "./ReferAFriendModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReferAFriendModal.vue?vue&type=style&index=0&id=0f929f37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f929f37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0f929f37', component.options)
    } else {
      api.reload('0f929f37', component.options)
    }
    module.hot.accept("./ReferAFriendModal.vue?vue&type=template&id=0f929f37&scoped=true&", function () {
      api.rerender('0f929f37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/referral/components/ReferAFriendModal.vue"
export default component.exports